window.groupForm = {}

window.groupForm.filterGroep = (data) => {
		
    while (data.telefoon.match(/[-]/)) {
        data.telefoon = data.telefoon.replace(/[-]/, '')
    }
    
    while (data.telefoon.match(/[\s]/)) {
        data.telefoon = data.telefoon.replace(/[\s]/, '')
    }
    
    data.telefoon = data.telefoon.replace('+310', '+31')
    
    while (data.emailadres.match(/[\s]/)) {
        data.emailadres = data.emailadres.replace(/[\s]/, '')
    }
    
    data.emailadres = data.emailadres.toLowerCase()
    
    return data
}

window.groupForm.validateGroep = (data, asHTMLList = false) => {
    
    const errors = []

    const addError = (selector, message) => {
        errors.push({
            selector,
            message,
        })
    }

    if (data.naam == '') {
        addError('naam', 'De naam is niet ingevoerd.')
    }
    
    if (data.telefoon != '') {
        
        if (!validateTelefoon(data.telefoon)) {
            addError('telefoon', 'Het ingevoerde telefoonnummer is ongeldig.')
        }
    }
    
    if (data.emailadres != '') {

        if (!validateEmailadres(data.emailadres)) {
            addError('emailadres', 'Het ingevoerde e-mailadres is ongeldig.')
        }
    }

    if (asHTMLList) {
        if (!errors.length) {
            return ''
        }
        const uniqueErrors = [...new Set(errors.map((error) => error.message))]
        return uniqueErrors.reduce((acc, cur) => {
            acc += '<li>' + cur + '</li>'
            return acc
        },'<ul>') + '</ul>'
    }
    
    return errors
}

window.groupForm.filterGroepslid = (data) => {
		
    return data
}

window.groupForm.validateGroepslid = (data, asHTMLList = false) => {
    
    const errors = []

    const addError = (selector, message) => {
        errors.push({
            selector,
            message,
        })
    }

    if (typeof data.type !== 'undefined' && data.type < 1) {
        addError('type', 'Er is geen type opgegeven.')
    }
    
    if (typeof data.type !== 'undefined') {
        
        if (data.type == 1) {
            
            if (data.persoon != parseInt(data.persoon) || data.persoon < 1) {
                addError('persoon', 'Er is geen persoon opgegeven.')
            }
            
        } else if (data.type == 2) {
            
            if (data.organisatie != parseInt(data.organisatie) || data.organisatie < 1) {
                addError('organisatie', 'Er is geen organisatie opgegeven.')
            }
            
        } else {
            
            if (data.medewerker != parseInt(data.medewerker) || data.medewerker < 1) {
                addError('medewerker', 'Er is geen medewerker opgegeven.')
            }
        }
    }
    
    if (asHTMLList) {
        if (!errors.length) {
            return ''
        }
        const uniqueErrors = [...new Set(errors.map((error) => error.message))]
        return uniqueErrors.reduce((acc, cur) => {
            acc += '<li>' + cur + '</li>'
            return acc
        },'<ul>') + '</ul>'
    }
    
    return errors
}

window.groupForm.filterKenmerk = (data) => {
    return data
}

window.groupForm.validateKenmerk = (data, asHTMLList = false) => {
    
    const errors = []

    const addError = (selector, message) => {
        errors.push({
            selector,
            message,
        })
    }

    if (data.kenmerk < 1) {
        addError('kenmerk', 'Er is geen kenmerk opgegeven.')
    }

    if (asHTMLList) {
        if (!errors.length) {
            return ''
        }
        const uniqueErrors = [...new Set(errors.map((error) => error.message))]
        return uniqueErrors.reduce((acc, cur) => {
            acc += '<li>' + cur + '</li>'
            return acc
        },'<ul>') + '</ul>'
    }
    
    return errors
}